import React, { useContext, useEffect, useState } from 'react';
import { DialogActions } from '@mui/material';
import { PiButton } from '@sensei/pi-component';
import { useMutation } from '@apollo/client';
import { ACCEPT_TERMS_AND_CONDITIONS } from '../../services/user.service';
import useTermsAndConditionsDialogStyles from '../../styles/terms-and-conditions-dialog/terms-and-conditions-dialog.style';
import { SnackbarContext } from '../../context/SnanckarContext';
import { UserType } from '../../types/user.type';
import { RoutesEnum } from '../../types/routes.enum';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import useAuth from '../../auth/use-auth';
import TermsAndConditionsDialog from '../terms-and-conditions-dialog/terms-and-conditions-dialog';

export default function TermsAndConditionsAutoOpenDialog() {
    const { isAuthenticated, user, setUser } = useAuth();
    const { setSnackbarContext } = useContext(SnackbarContext);
    const [acceptTermsAndConditions] = useMutation<{
        acceptTermsAndConditions: UserType;
    }>(ACCEPT_TERMS_AND_CONDITIONS);
    const classes = useTermsAndConditionsDialogStyles();
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const router = useRouter();
    const { t } = useTranslation();

    useEffect(() => {
        setPopupIsOpen(
            !!isAuthenticated &&
                !!user?.memberId &&
                !user.termsAndConditions?.accepted &&
                router.pathname !== RoutesEnum.BASE &&
                router.pathname !== RoutesEnum.INVITE &&
                user.memberId !== user.membersPortalEmailAddress,
        );
    }, [user, router, isAuthenticated]);

    const handleAcceptTermsAndConditions = () => {
        if (user?.membersPortalEmailAddress) {
            acceptTermsAndConditions({
                variables: {
                    membersPortalEmail: user.membersPortalEmailAddress,
                },
            })
                .then((response) => {
                    if (response.data) {
                        setUser(response.data.acceptTermsAndConditions);
                    }
                })
                .catch(() => {
                    setSnackbarContext({
                        open: true,
                        severity: 'error',
                        message:
                            'termsAndConditionsDialog.failedToAcceptMessage',
                    });
                });
        }
    };

    return (
        <TermsAndConditionsDialog isOpen={popupIsOpen}>
            <DialogActions className={classes.actions}>
                <PiButton
                    color="secondary"
                    onClick={() => router.push(RoutesEnum.LOGOUT)}
                    className={classes.actionButton}
                >
                    {t('termsAndConditionsDialog.logoutButton')}
                </PiButton>
                <PiButton
                    color="primary"
                    onClick={handleAcceptTermsAndConditions}
                    className={classes.actionButton}
                >
                    {t('termsAndConditionsDialog.acceptButton')}
                </PiButton>
            </DialogActions>
        </TermsAndConditionsDialog>
    );
}
